import * as cx from 'classnames';
import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';
import styles from './FormControl.mscss';

export interface OwnProps {

    // pls nestylujte form controls cez cssko zvonka (fontsize, farby, line-height, layout, ...)
    // vznika tak kopec bugov
    //
    // Radsej pridajte prop a ten poriadne dorieste v uzavretom kode
    // konkretneho form controlu, kde viete ze vam zvonku nikto nemeni assumptions.
    // A otestuje vasu zmenu tu: https://www-cemi.modrykonik.sk/forms-gallery/
    //
    // Splocne veci co platia pre form controls:
    // - vzdy je klikatelna plocha celeho form controlu (nie len elementy v strede)
    // - minimalna vyska form controlu je 55px. ale moze byt aj vacsia, vtedy sa input
    //   roztiahne a zaberie jeho celu vysku
    // - ikony napravo su vycetrovane v obdlzniku sirky 44px
    // - label alebo text inputu su vzdy 12px od bottom border, co je dosiahnute
    // roznym top paddingom, ktory je sucastou klikatelnej zony
    className?: string;
    classNames?: {
        label?: string;
    };

    label?: string;                // redux-form 7.x vyzaduje aby label bol string

    // props, ktore ovplyvnuju vzhlad form controlu
    minimizedLabel?: boolean;      // vynuti, aby label bol vzdy zmenseny hore
    marginLeft?: boolean;          // (ne)ma bocny margin
    bottomBorder?: boolean;        // (ne)kresli border na spodu
    fillRemainingSpace?: boolean;  // expand to fill remaining horizontal space (assumes <form> uses display: flex)
    transparent?: boolean;

    // Use only if you really know that error string is safe HTML
    dangerouslySetInnerHTMLForError?: boolean;  // FIXME to be removed, use @mkReduxForm instead
}

const FormControl: React.StatelessComponent<OwnProps & WrappedFieldProps> = ({
    input, meta: {active, touched, error, warning}, label,
    className, classNames = {}, children,
    minimizedLabel = false, marginLeft = true, bottomBorder = true, fillRemainingSpace = false,
    dangerouslySetInnerHTMLForError = false, transparent = false,
}) => (
    <div
        className={cx(className, styles.FormControl, {
            [styles['FormControl--active']]: active,
            [styles['FormControl--value']]: (!!input.value || !!error || minimizedLabel),
            [styles['FormControl--warning']]: touched && !!warning,
            [styles['FormControl--error']]: touched && !!error,
            [styles['FormControl--noBorder']]: !bottomBorder,
            [styles['FormControl--noMarginLeft']]: !marginLeft,
            [styles['FormControl--fillRemainingSpace']]: fillRemainingSpace,
            [styles['FormControl--transparent']]: transparent,
        })}
    >
        {!!label && (/* absolutely positioned label, has either normal or minimized size */
            <label htmlFor={input.name} className={cx(styles.FormControl__label, classNames.label)}>
                {label}
            </label>
        )}

        {children/* main input component */}

        {touched && error && <div className={styles.FormControl__error}>
            {dangerouslySetInnerHTMLForError ? (
                <span dangerouslySetInnerHTML={{ __html: error }} />
            ) : error}
        </div>}

        {touched && warning && <div className={styles.FormControl__warning}>{warning}</div>}
    </div>
);

export default FormControl;
